import {
    Collapse,
    ConfigProvider,
    Modal,
    Progress,
    Spin,
    Table,
    Tabs,
} from "antd";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import SideBar from "../../../components/SideBar";
import NavBar from "../../../components/NavBar";
import Footer from "../../../components/Footer";
import axiosInstance from "../../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../../variables/constants";
import { frenchDate } from "../../../variables/functions";
import frFR from "antd/locale/fr_FR";
import { rightsService } from "../../../services/rightsService";
import { toast } from "react-toastify";

const DetailsLotAttestationsAgence = () => {
    const [compagnie, setCompagnie] = useState("");
    const [reload, setReload] = useState(false);
    const [getLotLoading, setGetLotLoading] = useState(false);
    const [affectationModalOpen, setAffectationModalOpen] = useState(false);
    const [firstAttestation, setFirstAttestation] = useState(0);
    const [lastAttestation, setLastAttestation] = useState(0);
    const [nombre, setNombre] = useState(0);
    const [loading, setLoading] = useState(false);
    const [agences, setAgences] = useState([]);
    const [selectedAgence, setSelectedAgence] = useState("");

    const location = useLocation();
    const param = useParams();

    const [usedLots, setUsedLots] = useState([]);
    const [currentLots, setCurrentLots] = useState([]);

    useEffect(() => {
        const code = param.codeAgence
            ? param.codeAgence
            : LOGGED_USER.agence.codeAgence;
        setGetLotLoading(true);
        const data = location.state;
        const codeOrg = data?.codeOrganisme ? data.codeOrganisme : "00";

        axiosInstance
            .get(`/api/dispatched-lot-attestation/agency-stats/${code}/${codeOrg}`)
            .then((res) => {
                // console.log("DP", res.data);
                // setLots(res.data);
                setUsedLots(res?.data?.filter((element) => element?.updatedLot === 0));
                setCurrentLots(res?.data?.filter((element) => element?.updatedLot > 0));
                setReload(false);
                setGetLotLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setGetLotLoading(false);
            });

        axiosInstance
            .get(`/api/agence/organisme/code/${code}/${codeOrg}`)
            .then((res) => {
                // console.log(res.data);
                setCompagnie(res.data);
            })
            .catch((err) => {
                console.log(err);
                setGetLotLoading(false);
            });

        axiosInstance
            .get(`/api/agence/dtrf`)
            .then((res) => {
                setAgences(res.data.filter((element) => element.codeAgence !== code));
            })
            .catch((err) => {
                console.log(err);
            });

    }, [reload, param.codeAgence]);


    const columns = [
        {
            title: "Lot",
            dataIndex: "lot",
            key: "lot",
            render: (_, record) => (
                <h6 >
                    {`${record.start} - ${record.end} (${record.serie})`}
                </h6>
            ),
            align: "center",
        },
        {
            title: "Date de livraison",
            dataIndex: "dateReception",
            key: "dateReception",
            render: (_, record) => (
                <p
                    style={{
                        margin: 0,
                        color: record.dateReception
                            ? "#52c41a"
                            : "#faad14",
                    }}
                >
                    {record.dateReception
                        ? `Livré le ${frenchDate(
                            record.dateReception,
                        )}`
                        : "Pas encore livré"}
                </p>
            ),
            align: "center",
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            render: (_, record) => (
                <p
                    style={{
                        margin: 0,
                        color: "blue",
                    }}
                >
                    {record?.lot}
                </p>
            ),
            align: "center"
        },
        {
            title: "Nbre utilisés",
            dataIndex: "nbreUtilises",
            key: "nbreUtilises",
            render: (_, record) => (
                <p
                    style={{
                        margin: 0,
                        color: "blue",
                    }}
                >
                    {record?.lot - (record?.updatedLot || 0) - (record?.damagedLot || 0) - (record?.canceledLot || 0)}
                </p>
            ),
            align: "center",
        },
        {
            title: "Attestations endommagées",
            dataIndex: "attestationsEndommagees",
            key: "attestationsEndommagees",
            render: (_, record) => (
                <p
                    style={{
                        margin: 0,
                        color: "blue",
                    }}
                >
                    {record?.damagedLot}
                </p>
            ),
            align: "center",
        },
        {
            title: "Nbre restants",
            dataIndex: "nbreRestants",
            key: "nbreRestants",
            render: (_, record) => (
                <p
                    style={{
                        margin: 0,
                        color: "blue",
                    }}
                >
                    {record?.updatedLot}
                </p>
            ),
            align: "center",
        },
        {
            title: "Pourcentage",
            dataIndex: "pourcentage",
            key: "pourcentage",
            render: (_, record) => (
                <Progress
                    type="dashboard"
                    size={50}
                    percent={(
                        (100 *
                            (record.lot -
                                record.updatedLot)) /
                        record.lot
                    ).toFixed(2)}
                    strokeColor="blueviolet"
                />
            ),
            align: "center",
        },
    ];

    // Parse une saisie numérique d'attestation : renvoie "" si vide/invalide
    // (évite que parseInt("") = NaN ne se retrouve dans le state puis affiché à l'écran).
    const parseAttestationNumber = (value) => {
        const n = parseInt(value, 10);
        return Number.isNaN(n) ? "" : n;
    };

    // Contrôle commun : refuse tout lot vide / NaN / incohérent avant transfert.
    const validateAttestationRange = () => {
        const first = parseInt(firstAttestation, 10);
        const last = parseInt(lastAttestation, 10);
        const count = parseInt(nombre, 10);
        if (Number.isNaN(first) || Number.isNaN(last) || Number.isNaN(count)) {
            toast("Veuillez renseigner des numéros et un nombre d'attestation valides (champs non vides).");
            return false;
        }
        if (first <= 0 || last <= 0 || count <= 0) {
            toast("Les numéros et le nombre d'attestation doivent être supérieurs à zéro.");
            return false;
        }
        if (last < first) {
            toast("Le numéro de la dernière attestation doit être supérieur ou égal au premier.");
            return false;
        }
        if (count !== last - first + 1) {
            toast(`Le nombre saisi (${count}) ne correspond pas à la plage : il devrait être ${last - first + 1}.`);
            return false;
        }
        return true;
    };

    const onSubmit = () => {
        if (!validateAttestationRange()) return;
        {
            if (!selectedAgence) {
                toast("Veuillez choisir une agence");
                return;
            }
            let lotTransfert = {
                agence: compagnie,
                lot: [firstAttestation, lastAttestation],
                recepteur: agences?.find(element => element.codeId === selectedAgence),
            }
            console.log("lotTransfert", lotTransfert);
            axiosInstance
                .put(`/api/dispatched-lot-attestation/transfert`, JSON.stringify(lotTransfert))
                .then((res) => {
                    if (res.status === 200) {
                        setAffectationModalOpen(false);
                        setReload(true);
                        toast("Lot d'attestation ajoutée avec succès");
                    } else {
                        toast("Ce lot d'attestation n'existe pas ou est déjà utilisé");
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.status === 404) {
                        toast("Ce lot d'attestation n'existe pas ou est déjà utilisé");
                    } else {
                        toast("Erreur lors de l'ajout du lot d'attestation");
                    }
                    setLoading(false);
                });
        }
    }

    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <div class="row g-6 mb-6">
                                <div class="col-lg-12 col-xxl-12">
                                    <Spin spinning={getLotLoading}>
                                        <div class="card h-100">
                                            <div class="card-header d-flex align-items-center justify-content-between">
                                                <div class="card-title mb-0">
                                                    <h5 class="m-0 me-2">
                                                        Les lots d'attestations de {compagnie.nom}
                                                    </h5>
                                                </div>
                                                {rightsService("HLA061") && LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" ? (
                                                    <div class="dropdown">
                                                        <button
                                                            type="button"
                                                            class="btn btn-primary"
                                                            onClick={() => setAffectationModalOpen(true)}
                                                        >
                                                            Transférer un lot
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div class="card-body">
                                                <ConfigProvider locale={frFR}>
                                                    <Tabs
                                                        defaultActiveKey="1"
                                                        style={{ marginTop: 20 }}
                                                        items={[
                                                            {
                                                                key: 1,
                                                                label: "Liste des lots non utilisés",
                                                                children: (
                                                                    <div>
                                                                        <Collapse
                                                                            accordion
                                                                            bordered={false}
                                                                            style={{
                                                                                backgroundColor: "#f7f8fa",
                                                                                borderRadius: 8,
                                                                                boxShadow:
                                                                                    "0 4px 10px rgba(0, 0, 0, 0.1)",
                                                                            }}
                                                                        >
                                                                            <div className="container">
                                                                                <Table
                                                                                    columns={columns}
                                                                                    dataSource={currentLots}
                                                                                    pagination={{ pageSize: 10 }}
                                                                                    summary={(pageData) => {
                                                                                        const total = pageData.reduce((sum, record) => sum + record.lot, 0);
                                                                                        const used = pageData.reduce((sum, record) => sum + (record.lot - (record.updatedLot || 0) - (record.damagedLot || 0) - (record.canceledLot || 0)), 0);
                                                                                        const damaged = pageData.reduce((sum, record) => sum + record.damagedLot, 0);
                                                                                        const remaining = pageData.reduce((sum, record) => sum + record.updatedLot, 0);
                                                                                        const percentage = ((100 * used) / (total || 1)).toFixed(2);

                                                                                        const totalLots = currentLots.reduce((sum, r) => sum + r.lot, 0);
                                                                                        const totalUsed = currentLots.reduce((sum, r) => sum + (r.lot - r.updatedLot - (r.damagedLot || 0) - (r.canceledLot || 0)), 0);
                                                                                        const totalDamaged = currentLots.reduce((sum, r) => sum + r.damagedLot, 0);
                                                                                        const totalRemaining = currentLots.reduce((sum, r) => sum + r.updatedLot, 0);
                                                                                        const averagePercentage = currentLots.length > 0
                                                                                            ? ((100 * totalUsed) / (totalLots || 1)).toFixed(2)
                                                                                            : 0;

                                                                                        return (
                                                                                            <>
                                                                                                <Table.Summary.Row style={{ backgroundColor: "#e6ffed" }}>
                                                                                                    <Table.Summary.Cell index={0} colSpan={2}>
                                                                                                        <strong>Total</strong>
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={2} align="center">
                                                                                                        {total}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={3} align="center">
                                                                                                        {used}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={4} align="center">
                                                                                                        {damaged}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={5} align="center">
                                                                                                        {remaining}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={6} align="center">
                                                                                                        <Progress
                                                                                                            type="dashboard"
                                                                                                            size={50}
                                                                                                            percent={parseFloat(percentage)}
                                                                                                            strokeColor="blueviolet"
                                                                                                            style={{ color: "white" }}
                                                                                                        />                                                                                            </Table.Summary.Cell>
                                                                                                    {LOGGED_USER?.profil?.organisme?.typeOrganisme !== "POOL" && (
                                                                                                        <Table.Summary.Cell index={7}></Table.Summary.Cell>
                                                                                                    )}
                                                                                                </Table.Summary.Row>

                                                                                                <Table.Summary.Row style={{ backgroundColor: "gray", color: "white" }}>
                                                                                                    <Table.Summary.Cell index={0} colSpan={2}>
                                                                                                        <strong>Total général</strong>
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={2} align="center">
                                                                                                        {totalLots}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={3} align="center">
                                                                                                        {totalUsed}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={4} align="center">
                                                                                                        {totalDamaged}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={5} align="center">
                                                                                                        {totalRemaining}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={6} align="center">
                                                                                                        <Progress
                                                                                                            type="dashboard"
                                                                                                            size={50}
                                                                                                            percent={parseFloat(averagePercentage)}
                                                                                                            strokeColor="blueviolet"
                                                                                                        />                                                                                            </Table.Summary.Cell>
                                                                                                    {LOGGED_USER?.profil?.organisme?.typeOrganisme !== "POOL" && (
                                                                                                        <Table.Summary.Cell index={7}></Table.Summary.Cell>
                                                                                                    )}
                                                                                                </Table.Summary.Row>
                                                                                            </>
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                        </Collapse>
                                                                    </div>
                                                                ),
                                                            },
                                                            {
                                                                key: 2,
                                                                label: "Liste des lots utilisés",
                                                                children: (
                                                                    <div>
                                                                        <Collapse
                                                                            accordion
                                                                            bordered={false}
                                                                            style={{
                                                                                backgroundColor: "#f7f8fa",
                                                                                borderRadius: 8,
                                                                                boxShadow:
                                                                                    "0 4px 10px rgba(0, 0, 0, 0.1)",
                                                                            }}
                                                                        >
                                                                            <div className="container">
                                                                                <Table
                                                                                    columns={columns}
                                                                                    dataSource={usedLots}
                                                                                    pagination={{ pageSize: 10 }}
                                                                                    summary={(pageData) => {
                                                                                        const total = pageData.reduce((sum, record) => sum + record.lot, 0);
                                                                                        const used = pageData.reduce((sum, record) => sum + (record.lot - record.updatedLot - (record.damagedLot || 0) - (record.canceledLot || 0)), 0);
                                                                                        const damaged = pageData.reduce((sum, record) => sum + record.damagedLot, 0);
                                                                                        const remaining = pageData.reduce((sum, record) => sum + record.updatedLot, 0);
                                                                                        const percentage = ((100 * used) / (total || 1)).toFixed(2);

                                                                                        const totalLots = usedLots.reduce((sum, r) => sum + r.lot, 0);
                                                                                        const totalUsed = usedLots.reduce((sum, r) => sum + (r.lot - r.updatedLot - r.canceledLot - r.damagedLot), 0);
                                                                                        const totalDamaged = usedLots.reduce((sum, r) => sum + r.damagedLot, 0);
                                                                                        const totalRemaining = usedLots.reduce((sum, r) => sum + r.updatedLot, 0);
                                                                                        const averagePercentage = usedLots.length > 0
                                                                                            ? ((100 * totalUsed) / (totalLots || 1)).toFixed(2)
                                                                                            : 0;

                                                                                        return (
                                                                                            <>
                                                                                                <Table.Summary.Row style={{ backgroundColor: "#e6ffed" }}>
                                                                                                    <Table.Summary.Cell index={0} colSpan={2}>
                                                                                                        <strong>Total</strong>
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={2} align="center">
                                                                                                        {total}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={3} align="center">
                                                                                                        {used}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={4} align="center">
                                                                                                        {damaged}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={5} align="center">
                                                                                                        {remaining}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={6} align="center">
                                                                                                        <Progress
                                                                                                            type="dashboard"
                                                                                                            size={50}
                                                                                                            percent={parseFloat(percentage)}
                                                                                                            strokeColor="blueviolet"
                                                                                                            style={{ color: "white" }}
                                                                                                        />                                                                                            </Table.Summary.Cell>
                                                                                                    {LOGGED_USER?.profil?.organisme?.typeOrganisme !== "POOL" && (
                                                                                                        <Table.Summary.Cell index={7}></Table.Summary.Cell>
                                                                                                    )}
                                                                                                </Table.Summary.Row>

                                                                                                <Table.Summary.Row style={{ backgroundColor: "gray", color: "white" }}>
                                                                                                    <Table.Summary.Cell index={0} colSpan={2}>
                                                                                                        <strong>Total général</strong>
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={2} align="center">
                                                                                                        {totalLots}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={3} align="center">
                                                                                                        {totalUsed}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={4} align="center">
                                                                                                        {totalDamaged}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={5} align="center">
                                                                                                        {totalRemaining}
                                                                                                    </Table.Summary.Cell>
                                                                                                    <Table.Summary.Cell index={6} align="center">
                                                                                                        <Progress
                                                                                                            type="dashboard"
                                                                                                            size={50}
                                                                                                            percent={parseFloat(averagePercentage)}
                                                                                                            strokeColor="blueviolet"
                                                                                                        />                                                                                            </Table.Summary.Cell>
                                                                                                    {LOGGED_USER?.profil?.organisme?.typeOrganisme !== "POOL" && (
                                                                                                        <Table.Summary.Cell index={7}></Table.Summary.Cell>
                                                                                                    )}
                                                                                                </Table.Summary.Row>
                                                                                            </>


                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                        </Collapse>
                                                                    </div>
                                                                ),
                                                            },
                                                        ]}
                                                    />
                                                </ConfigProvider>
                                            </div>
                                        </div>
                                    </Spin>
                                </div>
                            </div>
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
                <Modal
                    open={affectationModalOpen}
                    loading={loading}
                    onOk={onSubmit}
                    onCancel={() => {
                        setFirstAttestation(0);
                        setLastAttestation(0);
                        setNombre(0);
                        setAffectationModalOpen(false);
                    }}
                    zIndex={1900}
                    cancelText="Annuler"
                    centered
                >
                    <div className="text-center mb-6">
                        <h4 className="address-title mb-2">Transfert de lot d'attestation </h4>
                        <p className="address-subtitle">
                            Transférer un lot d'attestation de <u>{compagnie?.nom}</u> vers une autre agence
                        </p>
                    </div>
                    <form id="addNewAddressForm" className="row g-5" onSubmit={onSubmit}>
                        <div className="col-12 col-md-12">
                            <label class="form-label" for="firstAttestation">
                                Veuillez entrer le numéro de la première attestation
                            </label>
                            <input
                                className="form-control" id="firstAttestation" value={firstAttestation}
                                name="firstAttestation"
                                onChange={(e) => {
                                    const v = parseAttestationNumber(e.target.value);
                                    setFirstAttestation(v);
                                    setLastAttestation(v);
                                }}
                                placeholder="Entrez le numéro de la première attestation" type="number" />
                        </div>
                        <div className="col-12 col-md-12">
                            <label class="form-label" for="lastAttestation">
                                Le nombre d'attestation
                            </label>
                            <input className="form-control" id="lastAttestation" value={nombre} name="lastAttestation"
                                onChange={(e) => setNombre(parseAttestationNumber(e.target.value))}
                                placeholder="Entrez le nombre d'attestation" type="number" />
                        </div>
                        <div className="col-12 col-md-12">
                            <label class="form-label" for="lastAttestation">
                                Veuillez entrer le numéro de la dernière attestation
                            </label>
                            <input className="form-control" id="lastAttestation" value={lastAttestation}
                                name="lastAttestation" onChange={(e) => setLastAttestation(parseAttestationNumber(e.target.value))}
                                placeholder="Entrez le numéro de la dernière attestation" type="number" />
                        </div>
                        <div className="col-12 col-md-12">
                            <label class="form-label" for="agence">
                                Veuillez sélectionner l'agence réceptrice
                            </label>
                            <select className="form-control" id="agence" value={selectedAgence}
                                name="typeAttestation" onChange={(e) => setSelectedAgence(e.target.value)}
                                placeholder="Sélectionner l'agence">
                                <option value="">Sélectionner l'agence</option>
                                {agences?.map((ag, id) => (<option key={id} value={ag.codeId}> {ag.nom} </option>))}
                            </select>
                        </div>
                    </form>
                </Modal>
            </div>

            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default DetailsLotAttestationsAgence;